import { Select } from '@material-ui/core';
import { rgba } from 'polished';
import styled from 'styled-components';

export const ItemSelectorContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  max-width: 70px;
`;

export const CustomSelect = styled(Select)`
  .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) =>
      props.bordercolor
        ? rgba(props.bordercolor, 0.8)
        : 'var(--color-blue-primary)'};
  }
  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) =>
      props.bordercolor || 'var(--color-blue-primary)'};
  }
  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) =>
      props.bordercolor || 'var(--color-blue-primary)'};
  }
  & .MuiSvgIcon-root {
    fill: ${(props) =>
      props.bordercolor || 'var(--color-blue-primary)'} !important;
  }
  & .MuiSelect-root {
    color: ${(props) => props.bordercolor || 'var(--color-blue-primary)'};
  }

  input:-webkit-autofill,
  input:-webkit-autofill:focus {
    transition: background-color 600000s 0s, color 600000s 0s;
  }
  input[data-autocompleted] {
    background-color: transparent !important;
  }
`;
